import EventEmitter from 'eventemitter3'
const events = new EventEmitter()
export default () => events
